export enum SpecialChar {
  DOT = '.-.-.-',
  COMMA = '--..--',
  QUESTION = '..--..',
  AMPERSAND = '.-...',
  APOSTROPHE = '.----.',
  SLASH = '-..-.',
  AT = '.--.-.',
  EQUAL = '-...-',
  EXCLAMATION = '-.-.--',
  PLUS = '.-.-.',
  MINUS = '-....-',
  OPEN_BRACKET = '-.--.',
  CLOSE_BRACKET = '-.--.-',
  COLON = '---...',
  DOUBLE_QUOTE = '.-..-.'
}
